module.exports = __webpack_public_path__ + "img/je.58ee2c6.svg";